import { render } from "./fotografia.vue?vue&type=template&id=4f2d310c"
import script from "./fotografia.vue?vue&type=script&lang=js"
export * from "./fotografia.vue?vue&type=script&lang=js"

import exportComponent from "/home/bovero/Downloads/sito_vue3/vueboot5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__